import { Base } from "../core/base.model";
import { Persona } from "../security/persona.model";

export class Historial extends Base{
    nombre: string;
    fecha_creacion: string;
    fecha_actualizacion: string;
    huella: string;
    id_empleado: number;
    id: string;
    entrada: string;
    salida: string;
    
}
